module.exports = __webpack_public_path__ + "img/lock-icon.9f70c006.jpg";